<template>
  <div class="shop-submit-order main">
    <div class="subtitle">
      <span @click="close">
        <i class="fa fa-chevron-left" style="margin: 0 4px" />
        {{ $t("menu.order-summary") }}
      </span>
      <span v-if="showTestButton" class="link test-btn is-uppercase" :class="{ 'has-text-danger': isTest }"
        @click="isTest = !isTest">
        {{ $t("test") }}<span v-if="!isTest">?</span>
      </span>
    </div>
    <div style="height: 8px; background-color: whitesmoke" />
    <div v-if="isTestFleet" class="notification is-danger" style="margin-bottom: 0; border-radius: 0">
      <p><b>TEST order only</b></p>
      <p>Contact us when shop is ready to go LIVE</p>
    </div>
    <div ref="scroll" class="wrapper no-scrollbar" :class="{ 'bg-pink': isTest }">
      <div class="details">
        <p>
          <span class="key">{{ $t("payment.fulfilment") }}:</span>
          <span @click="clearFulfilment">
            <strong>{{ translateFulfilmentType(fulfilment) }}</strong>
            <!-- <i class="grey">{{ translateFulfilmentType2(fulfilment) }}</i> -->
            <span v-if="!isDelivery && hasDeliveryOption" class="grey is-uppercase has-text-danger">
              *{{ $t("commerce.not-a-delivery") }}
            </span>
            <!-- <i class="fa fa-pencil-alt has-text-info" /> -->
            <span class="change has-text-grey link">{{ $t("change") }}</span>
          </span>
        </p>
        <p v-if="isDelivery" class="field is-grouped" style="margin-top: 6px; margin-bottom: 8px">
          <span class="key address-notes">
            {{ $t("menu.address-notes") }}:
            <!-- <i class="optional">Optional</i> -->
          </span>
          <!-- <i class="optional">
            {{ $t("optional") }}
          </i> -->
          <input class="input" type="text" placeholder="Unit #, house #, condo name" v-model="driverInstructions" />
        </p>
        <p v-if="!delayedDelivery">
          <span class="key">{{ $t("payment.time") }}:</span>
          <strong v-if="fulfilmentTime"><i class="far fa-clock" />&nbsp;{{ fulfilmentTime }}
            <span class="grey is-uppercase has-text-danger">*Not ASAP</span>
          </strong>
          <strong v-else>Now (ASAP)</strong>
          <span class="change has-text-grey link" @click="setFulfilmentTime">{{
            $t("change")
          }}</span>
        </p>
        <p>
          <span class="key">{{ $t("payment.order") }}:</span>
          <strong>{{ totalItems }} {{ $t("menu.items") }}</strong>
        </p>
        <p>
          <span class="key">{{ $t("total") }}:</span>
          <strong :class="{ 'has-text-grey': driverTip }">{{ symbol }}{{ totalValue }}</strong>
          <span v-if="hasSol" class="total-sol">{{ totalValueSOL }} SOL</span>
          <span v-if="isDelivery && !isThirdPartyDelivery && false" class="change has-text-info link"
            @click="setDriverTip">
            <span v-if="driverTip">Driver Tip: {{ symbol }}{{ driverTip }}</span>
            <span v-else>Add Driver Tip</span>
          </span>
        </p>
        <p v-if="driverTip">
          <span class="key">With Tip:</span>
          <strong>{{ symbol }}{{ totalValueWithTip }}</strong>
        </p>
        <!-- don't show Payment type for agent mode orders -->
        <!-- <p v-if="!agentModeData && payment"> -->
        <p v-if="payment">
          <span class="key">{{ $t("commerce.payment") }}:</span>
          <span v-if="payment" @click="clearPayment">
            <strong class="is-uppercase">{{ translatedPayment }}</strong>
            <!-- <i class="fa fa-pencil-alt has-text-info" /> -->
            <span class="change has-text-grey link">{{ $t("change") }}</span>
          </span>
        </p>
      </div>

      <div v-if="payment === 'sol' && !showPaymentSOL" class="have-change notification is-white"
        style="color: var(--crypto-primary)">
        <div v-if="isDelivery">
          <p style="margin-bottom: 6px">
            You will be able to pay the delivery driver for the goods using the
            Solana wallet of your choice.
          </p>
          <p style="margin-bottom: 6px">
            When the driver arrives with your delivery they will show you a SOL
            QR Code to scan.
          </p>
          <p>
            If you'd like to pay now you can order on a desktop chrome browser
            using Slope, Solflare, Solong or Phantom wallets.
          </p>
        </div>
        <div v-else>
          <i>{{ $t("payment.pay-at-shop") }}</i>
        </div>
      </div>

      <div v-else-if="payment === 'cash'">
        <div class="have-change notification is-white has-text-grey">
          <div v-if="isDelivery">
            <i>{{ $t("payment.please-have-exact-amount") }}
              {{ $t("payment.drivers-also-accept-pp-and-bt") }}
            </i>
            <span class="link" @click="showBankTransferInfo">{{
              $t("more")
            }}</span>
          </div>
          <div v-else>
            <i>{{ $t("payment.pay-at-shop") }}</i>
          </div>
        </div>
        <div class="field is-grouped">
          <p class="control buttons">
            <span class="button is-white" style="padding: 0">{{
              $t("payment.require-change-?")
            }}</span>
            <span class="button is-outlined" :class="requireChange ? 'has-text-grey' : 'is-black'"
              @click="requireChange = false">{{ $t("no") }}</span>
            <span class="button is-outlined" :class="requireChange ? 'is-black' : 'has-text-grey'"
              @click="requireChange = true">{{ $t("yes") }}</span>
          </p>
          <p v-if="requireChange" class="control is-expanded">
            <input class="input" type="number" v-model="changeFor" :placeholder="currency + 1000" />
          </p>
        </div>

        <div v-if="isDelivery" class="have-change notification is-white has-text-grey">
          <div>
            <i>Orders that require cash change may take longer to deliver as the
              driver needs to get the correct change first.</i>
          </div>
        </div>
      </div>

      <div v-else-if="payment === 'promptpay'" class="have-change notification is-white has-text-grey">
        <div v-if="isDelivery" class="has-text-link">
          <i>
            <!-- {{ $t("payment.drivers-accept-promptpay-and-bank-transfer") }} -->
            {{ $t("payment.payment-details-will-appear") }}
            {{ $t("payment.double-check-account-number") }}
          </i>
          <!-- <span class="link" @click="showBankTransferInfo">{{ $t("more") }}</span> -->
        </div>
        <div v-else>
          <i>{{ $t("payment.pay-at-shop") }}</i>
        </div>
      </div>

      <div v-else-if="payment === 'bank-transfer'" class="have-change notification is-white has-text-grey">
        <div v-if="isDelivery" class="has-text-link">
          <i>
            <!-- {{ $t("payment.drivers-accept-promptpay-and-bank-transfer") }} -->
            <p>
              {{ $t("payment.payment-details-will-appear") }}
              {{ $t("payment.double-check-account-number") }}
            </p>
          </i>
          <!-- <span class="link" @click="showBankTransferInfo">{{ $t("more") }}</span> -->
        </div>
        <div v-else>
          <i>{{ $t("payment.pay-at-shop") }}</i>
        </div>
      </div>

      <collapse-transition>
        <PaymentPayNow v-if="payment === 'paynow'" :accountName="commerce.paynow.name" :type="commerce.paynow.type"
          :paymentID="commerce.paynow.id" :price="totalValue" :refNumber="'10'" :businessName="business.name" />
      </collapse-transition>

      <div v-if="!payment" class="payment-selector">
        <span style="font-size: 1.2em; font-weight: 500; color: #999">
          <span v-if="isPayInSOL">
            Pay in SOL
            <!-- <span v-if="isDesktop">Pay Now in SOL</span>
            <span v-else @click="forceSOL = !forceSOL"
              >Pay on Delivery in SOL</span
            > -->
            <span v-if="forceSOL" class="is-pulled-right tag" style="color: var(--crypto-primary)">beta</span>
          </span>
          <span v-else-if="isDelivery">{{
            $t("payment.pay-on-delivery")
          }}</span>
          <!-- <span v-if="isDelivery">{{ $t("payment.pay-on-delivery") }}</span> -->
          <span v-else>{{ $t("payment.pay-at-the-shop") }}</span>
        </span>
        <div class="buttons">
          <div v-if="hasSol" :class="btnClass" @click="setPayment('sol')">
            <p>
              <!-- <i class="fab fa-bitcoin payment-icon" /> -->
              <i class="fa fa-coins payment-icon" />
              <span class="payment-name">SOL</span>
            </p>
          </div>
          <div v-show="hasCreditCard" :class="btnClass" @click="setPayment('card')">
            <p>
              <i class="fa fa-credit-card payment-icon" />
              <span class="payment-name">{{ $t("payment.card") }}</span>
              <!-- <span class="is-pulled-right" style="margin-top: 2px"
                >−{{ currency }}15</span
              > -->
            </p>
          </div>
          <div v-if="hasCash" :class="btnClass" @click="setPayment('cash')">
            <p>
              <i class="fa fa-money-bill-wave payment-icon" />
              <span class="payment-name">{{ $t("payment.cash") }}</span>
              <i v-if="isContactlessDelivery" class="no-contactless">*Not for Contactless Delivery</i>
              <!-- <span class="is-pulled-right">{{ currency }}0</span> -->
            </p>
          </div>
          <div v-else :class="btnClass" disabled @click="noCashPaymentInfo">
            <p>
              <i class="fa fa-money-bill-wave payment-icon" />
              <span class="payment-name">{{ $t("payment.cash") }}</span>
              <span class="not-available">Not Available</span>
            </p>
          </div>
          <div v-show="hasPromptPay" :class="btnClass" @click="setPayment('promptpay')">
            <p>
              <i class="fa fa-qrcode payment-icon" />
              <span class="payment-name">{{ $t("payment.promptpay") }}</span>
              <!-- <span class="is-pulled-right">{{ currency }}0</span> -->
            </p>
          </div>
          <div v-show="hasBankTransfer" :class="btnClass" @click="setPayment('bank-transfer')">
            <p>
              <i class="fa fa-university payment-icon" />
              <span class="payment-name">{{
                $t("payment.bank-transfer")
              }}</span>
              <!-- <span class="is-pulled-right">{{ currency }}0</span> -->
            </p>
          </div>
          <!-- TODO for SG -->
          <div v-show="hasPaynow" :class="btnClass" @click="setPayment('paynow')">
            <p>
              <i class="fa fa-qrcode payment-icon" />
              <span class="payment-name">PayNow</span>
              <!-- <span class="is-pulled-right">{{ currency }}0</span> -->
            </p>
          </div>
        </div>
      </div>

      <div v-if="payment">
        <div v-if="acknowledgeThis" class="acknowledge-wrapper" @click="acknowledge">
          <div class="notification is-white">
            <p style="margin-bottom: 12px">
              <i v-html="acknowledgeThis" />
            </p>
            <collapse-transition>
              <p v-if="triggered" class="has-text-success has-text-centered" style="margin: 12px" key="1">
                <i class="fa fa-check-circle fa-3x" />
              </p>
              <p v-else key="2">
                <a class="button is-warning is-fullwidth">{{
                  $t("payment.i-acknowledge")
                }}</a>
              </p>
            </collapse-transition>
          </div>
        </div>

        <div v-else-if="requireIdentification && !identificationConfirmed">
          <div class="payment-selector">
            <ShopUploadIdentification :workflowID="workflowID" @close="checkIdentification" />
          </div>
        </div>

        <div v-else>
          <div v-if="payment === 'card'">
            <PaymentCreditCard v-if="payment === 'card'" :price="totalValue" :refNumber="'10'" :business="business"
              :currency="'sgd'" @submit="submit" />
          </div>

          <div v-else-if="payment === 'sol' && showPaymentSOL">
            <!-- <PaymentSOL :price="totalValue" @submit="submit" /> -->
            SOL Payment Component DISABLED
          </div>

          <!-- <div v-if="payment !== 'card'" style="margin: 20px 0"> -->
          <div v-else style="margin: 20px 0; padding: 0 8px">
            <p class="button is-medium is-fullwidth pulse" :class="isTest ? 'is-danger' : 'is-success'" @click="submit">
              <span v-if="isTest">Place Test Order</span>
              <span v-else>{{ $t("payment.place-order") }}</span>
            </p>
          </div>
        </div>
      </div>

      <div v-if="hasOngoingOrderSameShop" class="notification is-warning"
        style="margin-top: 20px; border: 2px solid black" @click="goto('orders')">
        <p>You already have an ongoing order with this shop.</p>
        <p>Are you sure you want to place another?</p>
        <p class="has-text-right" style="margin-top: 8px; font-weight: 550">
          <span class="button is-white has-text-link">See your ongoing orders&nbsp;<i class="fa fa-chevron-right" />
          </span>
        </p>
      </div>

      <LocalPhoneRequiredPanel v-if="showLocalPhoneRequired" @submit="submitWithLocalContact"
        @close="showLocalPhoneRequired = false" />

      <DriverInstructionsRequiredPanel v-if="showDriverInstructionsRequired" @submit="submitWithInstructions"
        @close="showDriverInstructionsRequired = false" />

    </div>
  </div>
</template>

<script>
import PaymentPayNow from "@/components/PaymentPayNow.vue";
import PaymentCreditCard from "@/components/PaymentCreditCard.vue";
// import PaymentSOL from "@/components/PaymentSOL.vue";
import ShopUploadIdentification from "@/components/ShopUploadIdentification.vue";
import LocalPhoneRequiredPanel from "@/components/LocalPhoneRequiredPanel.vue";
import DriverInstructionsRequiredPanel from "@/components/DriverInstructionsRequiredPanel.vue";

export default {
  name: "ShopSubmitOrder",
  components: {
    PaymentPayNow,
    PaymentCreditCard,
    // PaymentSOL,
    ShopUploadIdentification,
    LocalPhoneRequiredPanel,
    DriverInstructionsRequiredPanel,
  },
  props: {
    business: Object, // transport workflow, should be array
    commerce: Object, // commerce workflow data obj
    currency: String,
    fulfilment: String,
    totalItems: Number,
    totalValue: Number,
    address: Object,
    cashback: Number,
    agentModeData: Object,
    deliveryFee: Number, // original customer delivery fee
    shopDeliveryFee: Number, // shop delivery fee if they're paying
    delayedDelivery: Boolean,
    isThirdPartyDelivery: Boolean, // e.g. Lalamove
    isContactlessDelivery: String, // actually it's a string note, not a bool
    isTestFleet: Boolean, // force test mode if fleet is Test Express Delivery
    workflowID: String, // used to get member role in ShopUploadIdentification
  },
  data() {
    return {
      localContact: null,
      showDriverInstructionsRequired: false,
      showLocalPhoneRequired: false,
      driverTip: null,
      changeFor: null, // 1000, 500 etc
      requireChange: false,
      forceSOL: true, //false,
      payment: null, // user will set payment method
      showHint: false,
      isShort: true,
      isTest: false, // moved from previous page
      driverInstructions: null, //"test",
      fulfilmentTime: null,
      btnClass: `button is-fullwidth is-success`,
      acknowledged: false,
      triggered: false,
      identificationConfirmed: false,
      notDeliveryConfirmation: `IMPORTANT: You've selected not to receive your order via Delivery.
      <br><br>Please confirm you do not require Delivery for this order.`,
    };
  },
  computed: {
    disableAdvanceOrder() {
      return this.commerce.disable_advance_order
    },
    requireLocalContact() {
      var phoneNumber = this.$store.getters.phoneNumber;
      if (!phoneNumber || phoneNumber.length < 8) return true;
      return !phoneNumber.startsWith("+66");
    },
    requireIdentification() {
      if (!this.commerce.membership) return false;
      if (this.commerce.membership.require_identification) {
        // check if already has customer role for this shop with identification_pic_url
        return true;
      }
      return false;
    },
    identificationPic() {
      // check if has customer role with identification_pic_url
      return null;
    },
    showPaymentSOL() {
      return false;
      // if (this.payment !== "sol") return false;
      // return this.isDesktop || this.forceSOL;
    },
    totalValueSOL() {
      return this.convertEURtoSOLPretty(this.totalValue); //this.totalValue / 212; // 212 EUR to SOL on 8 Nov
    },
    totalValueWithTip() {
      return this.totalValue + this.driverTip;
    },
    hasOngoingOrderSameShop() {
      return this.$store.getters.getOngoingCustomerTransactions.filter(
        (t) => t.business_id === this.business.id //t.workflow_type_name === "Commerce"
      ).length;
    },
    hasOngoingOrder() {
      return this.$store.getters.getOngoingCustomerTransactions.length;
    },
    actualDeliveryFee() {
      return this.deliveryFee + this.shopDeliveryFee;
    },
    hasDeliveryOption() {
      var fulfilmentOptions = this.commerce.fulfilment_options;
      if (!fulfilmentOptions || !fulfilmentOptions.length) return true; // hack
      return fulfilmentOptions.includes("delivery");
    },
    acknowledgeThis() {
      if (this.acknowledged && this.triggered) return null;
      if (this.isDelivery && this.deliveryInfoBlurb) {
        return this.deliveryInfoBlurb;
      }
      if (this.isTakeAway && this.takeAwayInfoBlurb) {
        return this.takeAwayInfoBlurb;
      }
      if (!this.isDelivery && this.hasDeliveryOption) {
        return this.notDeliveryConfirmation;
      }
      return null;
    },
    showTestButton() {
      if (this.isTestFleet) return false; // don't show if Test Express Delivery
      return this.$store.getters.isCommerceAgent || this.isSuperUser();
    },
    symbol() {
      return this.currencySymbol(this.business.country);
    },
    hasSol() {
      return this.business.country === "pt";
      // if (!this.commerce.payment_options) return false; // default
      // return this.commerce.payment_options.includes("sol");
    },
    hasCreditCard() {
      if (!this.commerce.payment_options) return false; // default
      return this.commerce.payment_options.includes("card");
    },
    isLateDeliveryNotAllowCash() {
      if (!this.isDelivery) return false;
      var timeInt = parseInt(this.$date.getHHMM()); // 2230
      return timeInt > 2220;
    },
    isEarlyDeliveryNotAllowCash() {
      if (!this.isDelivery) return false;
      var timeInt = parseInt(this.$date.getHHMM()); // 2230
      return timeInt < 900;
    },
    hasCash() {
      if (this.isEarlyDeliveryNotAllowCash) return false;
      if (this.isLateDeliveryNotAllowCash) return false;
      if (!this.commerce.payment_options) return true; // default allow cash if payment_options not defined
      return this.commerce.payment_options.includes("cash");
    },
    hasPromptPay() {
      return this.business.country === "th";
      // if (!this.commerce.payment_options) return true; // default
      // return this.commerce.payment_options.includes("cash");
    },
    hasBankTransfer() {
      return this.business.country === "th";
      // return true; // should check commerce json
    },
    hasPaynow() {
      return this.business.country === "sg";
      // if (!this.commerce.payment_options) return false; // default
      // if (this.commerce.payment_options.includes("paynow")) {
      //   if (this.commerce.paynow) return true;
      // }
      // return false;
    },
    // paymentMethods() {
    //   return this.commerce.pay;
    // },
    hasMultiplePaymentMethods() {
      return this.hasPaynow; // hack for now
    },
    translatedPayment() {
      return this.translatePayment(this.payment) || this.payment;
    },
    isPayInSOL() {
      return this.business.country === "pt";
    },
    isDesktop() {
      return this.$store.state.width > 450;
    },
    isDelivery() {
      return this.fulfilment === "delivery";
    },
    isTakeAway() {
      return this.fulfilment === "take-away";
    },
    deliveryInfoBlurb() {
      if (!this.commerce.delivery_options) return null;
      return this.commerce.delivery_options.blurb;
    },
    takeAwayInfoBlurb() {
      if (!this.commerce.takeaway_options) return null;
      return this.commerce.takeaway_options.blurb;
    },
    blockMultipleOrders() {
      var user = this.$store.state.user;
      if (!user || !user.data.order_options) return false;
      return user.data.order_options.block_multiple;
    },
    blockCommerceMessage() {
      var user = this.$store.state.user;
      if (!user || !user.data) return null
      return user.data.block_commerce_message;
    },
  },
  mounted() {
    if (this.address) this.driverInstructions = this.address.notes;
    if (this.agentModeData) this.handleTukExpress();
    if (this.isTestFleet) this.isTest = true;
    // if (!this.business.is_active) this.isTest = true;
    this.triggerHint(1000);
  },
  methods: {
    checkIdentification(IDPicURL) {
      if (IDPicURL) this.identificationConfirmed = true;
    },
    noCashPaymentInfo() {
      console.log("noCashPaymentInfo", this.$date.getHHMM());
      if (this.isLateDeliveryNotAllowCash) {
        var lateMsg = `This shop does not accept<br>cash on delivery orders<br>late at night`;
        this.infoToast(lateMsg);
        return;
      }
      var msg = `This shop does not accept<br>cash on delivery orders`;
      this.infoToast(msg);
    },
    setDriverTip() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
         <i class='fa fa-motorcycle'></i>&nbsp;Set Driver Tip</p>
        </p>
        <p style='margin-bottom:10px'>Tipping is optional. The full tip amount goes to the driver.</p>
        <p style='margin-bottom:10px'>If you set a driver tip now it will be shown to the driver as a priority tip
        <i>and cannot be removed</i>.</p>
        <p>If you don't want the driver to know the tip amount, or if you want to decide on a tip amount later 
          <i>do not enter a tip amount here</i>
        .</p>
        </div>`,
        input: "number",
        inputPlaceholder: this.currency + "10",
        confirmButtonText: this.$t("payment.set-tip"),
        cancelButtonText: this.$t("payment.cancel-tip"),
        showCancelButton: true,
        showCloseButton: true,
      }).then((val) => {
        if (val.value) this.driverTip = parseInt(val.value);
        if (val.dismiss === "cancel") this.driverTip = 0;
      });
    },
    setFulfilmentTime() {
      if (this.disableAdvanceOrder) {
        this.errorToast(`This shop does not accept Advance Orders.<br>Please order only when you<br>are ready to receive the order.`, "top", 10000)
        return
      }
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='far fa-clock'></i>&nbsp;Set Fulfilment Time</p>
        <p style='margin-bottom:10px'>By default, shops handle orders as soon as they receive them during open hours.</p>
        <p>If you want your order to be fulfilled at a later time today, please enter your desired fulfilment time and <strong>call the shop to confirm with them</strong>.</p>
        </div>`,
        input: "number",
        inputValue: parseInt(this.fulfilmentTime),
        inputPlaceholder: "2100",
        inputValidator: (val) => {
          if (
            !val ||
            val.length !== 4 ||
            val.slice(0, 2) > 23 ||
            val.slice(2) > 59
          )
            return `Enter a valid time like 0900 or 2130`;
          var minTime = parseInt(this.$date.getHHMM()) + 100; // add an hour
          if (parseInt(val) < minTime)
            return `Enter a time later today after ${minTime}, otherwise choose "Now"`;
        },
        showCancelButton: true,
        showCloseButton: true,
        cancelButtonColor: this.bulmaColor("primary"),
        confirmButtonText: "Later (Set a Time)",
        cancelButtonText: "Now (ASAP)",
      }).then((val) => {
        if (val.value) {
          var str = val.value;
          if (str.length === 3) {
            this.fulfilmentTime = "0" + str.slice(0, 1) + ":" + str.slice(2);
          } else {
            this.fulfilmentTime = str.slice(0, 2) + ":" + str.slice(2);
          }
          this.reminderToCallTheShop();
        } else {
          this.fulfilmentTime = null;
        }
      });
    },
    reminderToCallTheShop() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:2em;'>🙏 Important Reminder</p>
        <p style='margin-bottom:10px'>
        Please remember to call the shop <strong>after placing this order</strong> to confirm your desired fulfilment time.
        </p>
        <p>This will help the shop to avoid accidentally preparing your order at the wrong time.</p>
        </div>`,
      });
    },
    handleTukExpress() {
      this.payment = "cash";
      this.submit();
    },
    editAgentOrder() {
      this.$emit("editAgentOrder");
      this.close();
    },
    acknowledge() {
      this.triggered = true;
      setTimeout(() => (this.acknowledged = true), 800);
    },
    showBankTransferInfo() {
      var msg = `<div style='text-align:left'>
      Just ask the driver for their<br>PromptPay or Bank Transfer details<br>when they arrive with your delivery.
      </div>`;
      this.infoToast(msg, "bottom", 9000);
    },
    triggerHint(initial) {
      if (!initial) initial = 0;
      setTimeout(() => (this.showHint = true), initial);
      // setTimeout(() => (this.showHint = false), 5000);
    },
    setPayment(method) {
      this.log("set_payment_method", method);
      if (method === "paynow") {
        this.isShort = false;
        setTimeout(() => this.scrollToBottom(), 400);
      }
      this.payment = method;
    },
    clearPayment() {
      this.isShort = true;
      this.payment = null;
      this.triggerHint(600);
    },
    clearFulfilment() {
      this.$emit("clearFulfilment");
      this.close();
    },
    close() {
      this.$emit("close");
    },
    // getCashback() {
    //   this.$emit("cashback");
    //   this.$emit("close");
    // },
    promptChange() {
      var amount = this.currency + this.totalValue;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-coins'></i>&nbsp;Do you need change?</p>
        <p style='margin-bottom:10px'>Please enter the amount you have so the driver can prepare the correct change.</p>
        <p>The order value is ${amount}, so enter a larger amount for change, else click No.</p>`,
        input: "number",
        inputPlaceholder: this.currency + "1000",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        showCancelButton: true,
        allowOutsideClick: false,
        inputValidator: (val) => {
          if (!val || val <= this.totalValue)
            return "Enter a valid amount or click No";
        },
      }).then((val) => {
        if (val.value) {
          this.changeFor = parseInt(val.value);
          this.submit();
        } else {
          this.requireChange = false;
        }
      });
    },
    invalidChangeFor() {
      if (!this.changeFor) return true;
      return parseInt(this.changeFor) <= parseInt(this.totalValue);
    },
    showHasOngoingOrderAlert() {
      // some users are not allowed to have multiple orders
      this.$swal({
        html: `<div style='text-align: left'>
          <p style='font-size:1.2em; margin-bottom:12px'>
            <i class='fa fa-shopping-basket'></i>&nbsp;
            You have an ongoing order
          </p>
          <p style='margin-bottom:10px'>
            You can make a new order when the current order has been completed.
          </p>
          <p>Contact the shop you ordered from if you require assistance.</p>
          </div>`,
        confirmButtonText: "View Order <i class='fa fa-chevron-right'></i>"
      }).then(() => {
        this.goto("/orders")
      })
      var name = this.$store.getters.getNameAndNumber;
      var msg = `🚫 Blocked multiple order from [${name}]`;
      this.sendSuperuserNotification(msg);
    },
    submitWithLocalContact(localContact) {
      var msg = `⚠ 💬 ORDER LOCAL CONTACT 📞 ${localContact} @ ${this.business.name}`;
      this.sendSuperuserNotification(msg);
      this.localContact = localContact;
      this.submit();
    },
    submitWithInstructions(instructions) {
      this.driverInstructions = instructions;
      this.submit();
    },
    showBlockCommerceMessage() {
      var msg = `🍄 BLOCK COMMERCE MSG @ ${this.business.name}: ${this.blockCommerceMessage}`;
      this.sendSuperuserNotification(msg);
      this.$swal({
        html: `<div style='text-align:left'>
          <h1 style='font-size:1.2em; margin-bottom:12px'>Order was not placed</h1>
          <p style='margin-bottom:10px'>There was an issue with your order:</p>
          <p><i>${this.blockCommerceMessage}</i></p>
          </div>`,
        type: "error"
      })
    },
    submit(paymentID) {
      if (this.blockCommerceMessage) {
        this.showBlockCommerceMessage();
        return;
      }
      this.log("place_order", this.payment);
      if (this.hasOngoingOrder && this.blockMultipleOrders) {
        this.showHasOngoingOrderAlert();
        return;
      }
      if (this.requireChange && this.invalidChangeFor()) {
        this.promptChange();
        return;
      }
      if (!this.payment) {
        if (this.hasMultiplePaymentMethods) {
          this.triggerHint();
          this.log("set_payment_method_first");
          return this.errorToast("Select a payment method first");
        } else {
          this.setPayment("cash");
          this.log("set_payment_method_default");
          return this.infoToast("Default payment method selected");
        }
      }
      if (this.requireLocalContact && !this.localContact) {
        this.showLocalPhoneRequired = true;
        return;
      }
      if (this.isDelivery && !this.driverInstructions) {
        this.showDriverInstructionsRequired = true;
        return;
      }
      var data = {
        method: this.payment,
        isTest: this.isTest,
        fulfilmentTime: this.fulfilmentTime,
        driverTip: this.driverTip,
      };
      if (this.localContact) {
        data.localContact = this.localContact;
      }
      if (this.isDelivery && this.address.notes !== this.driverInstructions) {
        data.addressNotes = this.driverInstructions;
      }
      if (this.payment === "cash" && this.requireChange) {
        data.changeFor = parseInt(this.changeFor);
        // var changeMsg = `🤑 Request for Change 💰 ${this.changeFor} @ ${this.business.name}`;
        // this.sendSuperuserNotification(changeMsg);
      }
      if (this.payment === "card") data.id = paymentID; // only set payment_id for card payments
      // should set some payment_id for SOL payment?
      this.$emit("submit", data);
      if (this.fulfilmentTime) {
        var msg = ` ☢️ SCHEDULED COMMERCE ORDER ⚠ ⛔️ @ ${this.fulfilmentTime} for ${this.business.name}`;
        this.sendSuperuserNotification(msg);
      }
      this.close();
    },
    scrollToBottom() {
      var opts = { top: 999, behavior: "smooth" }; // big number to scroll to bottom
      this.$refs.scroll.scrollTo(opts);
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  width: 100vw;
  max-width: 700px;
  bottom: 0;
  height: calc(100vh - 100px);
  background-color: white;
  /* background-color: whitesmoke; */
  /* background-color: rgba(245, 245, 245, 0.95); */
  z-index: 21;
  backdrop-filter: blur(12px);
  overflow: hidden;
  text-align: left;
}

.wrapper {
  padding: 4px 6px;
  padding-bottom: 150px;
  height: calc(100vh - 100px);
  overflow: auto;
}

.subtitle {
  width: 100%;
  display: inline-block;
  /* color: white; */
  opacity: 0.9;
  font-weight: 450;
  /* margin-left: 10px; */
  margin-bottom: 0;
  vertical-align: top;
  line-height: 35px;
  padding: 4px 6px;
}

.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}

img {
  display: inline-block;
  /* position: absolute; */
  /* left: 12px; */
  height: 35px;
  /* background-color: white; */
}

.notification {
  padding: 12px;
}

.amount {
  display: inline-block;
  width: 40px;
}

.key {
  display: inline-block;
  font-weight: 550;
  color: rgba(47, 47, 47, 0.429);
  margin-right: 6px;
  width: 90px;
}

.total-sol {
  margin-left: 6px;
  background-color: var(--crypto-secondary);
  /* color: var(--crypto-primary); */
  padding: 0 4px;
  border-radius: 3px;
  font-weight: 500;
  color: black;
}

.address-notes {
  line-height: 1;
}

.pulse {
  animation: shadow-pulse-gold 1.5s infinite;
}

@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px gold;
  }

  100% {
    box-shadow: 0 0 0 8px rgba(255, 217, 0, 0.4);
  }
}

@keyframes shadow-pulse-blue {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 255, 255);
  }

  100% {
    box-shadow: 0 0 0 8px rgba(0, 255, 255, 0.3);
  }
}

.fa-pencil-alt {
  /* color: lightgreen; */
  margin-left: 6px;
}

.details {
  /* margin: 15px 0; */
  margin: 0;
  margin-bottom: 15px;
}

.details p {
  line-height: 1.8em;
}

.choose-one {
  position: absolute;
  right: 10px;
  font-size: 0.85em;
  padding: 4px;
  margin-bottom: 8px;
  color: blue;
  background-color: rgb(255, 242, 0);
  border-radius: 4px;
}

.have-change {
  font-size: 0.9em;
  margin-top: -10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  /* color: white; */
}

.is-test {
  margin-top: -4px;
  font-size: 0.8em;
}

.grey {
  font-weight: 600;
  color: rgb(151, 151, 151);
  font-size: 0.7em;
  margin-left: 6px;
  /* text-decoration: underline overline; */
}

.input {
  max-width: calc(100vw - 105px);
}

.link {
  border-bottom: 1px #ccc dotted;
}

.buttons .button {
  margin-bottom: 14px;
}

/* .buttons .fa {
  font-size: 1.5em;
} */

/* .buttons .button span {
  width: 100px;
  margin-left: 12px;
  text-align: right;
  font-weight: 550;
} */

.optional {
  position: absolute;
  right: 18px;
  margin-top: 28px;
  /* left: 116px;
  margin-top: -5px; */
  font-size: 0.7em;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.5);
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.6);
  line-height: 1;
  padding: 2px;
  border-radius: 3px;
}

/* .optional {
  font-size: 0.7em;
  font-weight: 550;
} */
.have-change.notification {
  padding: 8px;
}

.test-btn {
  float: right;
  padding-top: 4px;
  margin-right: 4px;
  color: grey;
  font-size: 0.8em;
  line-height: 1.4;
}

.bg-pink {
  background-color: rgba(255, 192, 203, 0.6);
}

.change {
  float: right;
  font-weight: 500;
  font-size: 0.9em;
  line-height: 1.5;
  margin-top: 4px;
}

.songkran {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 20px;
}

.payment-selector {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  background-color: white;
}

.payment-selector .buttons {
  margin-top: 10px;
}

.button p {
  width: 100%;
  text-align: left;
  display: table;
  font-weight: 550;
}

/* .button p > span {
  display: table-cell;
  vertical-align: middle;
} */
.payment-icon {
  width: 36px;
  margin-top: 4px;
  font-size: 1.3em;
}

.payment-name {
  /* display:inline-block; */
  text-align: left;
  margin-top: -4px;
  vertical-align: center;
}

.acknowledge-wrapper {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.no-contactless {
  font-weight: 450;
  margin-left: 6px;
  font-size: 0.8em;
  color: black;
}

.not-available {
  float: right;
  padding: 4px 0;
  font-weight: 400;
  font-size: 0.9em;
}
</style>